import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterMemoriaCalculoFatorCorrecaoTable = (props) => {
    const datalakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)

        datalakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        }).catch((err) => {
            props.loading(false)
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "CETIP": "N/A",
            "Indexador": "N/A",
            "Defasagem": 0,
            "CalculoDiasIndexador": "N/A",
            "FormulaIndexador": "N/A",
            "PeriodicidadeAtualizacaoMonetaria": "N/A",
            "MêsAniversarioAnualSemestral": "N/A",
            "ProjecaoInflacao": 0,
            "InflacaoNegativa": 0,
            "RecalculoProjecao": 0,
            "CalculoFatorCorrecao": "N/A",
            "CasasFatorCorrecao": 0,
            "DataEvento": dayjs().format(DATE_FORMAT),
            "DataAniversarioAnterior": dayjs().format(DATE_FORMAT),
            "DataAniversario": dayjs().format(DATE_FORMAT),
            "DataAniversarioPeriodo": dayjs().format(DATE_FORMAT),
            "DataReferenciaIndice": dayjs().format(DATE_FORMAT),
            "DataIndexador": dayjs().format(DATE_FORMAT),
            "dp": 0,
            "dt": 0,
            "VariacaoIndicePUPAR": 0,
            "FatorCorrecaoPUPAR": 0,
            "FatorCorrecaoAcumuladoPUPAR": 0,
            "FatorCorrecaoAcumuladoPeriodoPUPAR": 0,
            "VariacaoIndicePUMTM": 0,
            "FatorCorrecaoPUMTM": 0,
            "FatorCorrecaoAcumuladoPUMTM": 0,
            "FatorCorrecaoAcumuladoPeriodoPUMTM": 0
        }

        props.loading(true)

        return datalakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)

            console.error("Erro ao criar registro:")
            console.error("Mensagem:", err?.message)
            console.error("Response:", err?.response)
            console.error("Response data:", err?.response?.data)
            console.error("Status:", err?.response?.status)

            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            CETIP,
            Indexador,
            Defasagem,
            CalculoDiasIndexador,
            FormulaIndexador,
            PeriodicidadeAtualizacaoMonetaria,
            MêsAniversarioAnualSemestral,
            ProjecaoInflacao,
            InflacaoNegativa,
            RecalculoProjecao,
            CalculoFatorCorrecao,
            CasasFatorCorrecao,
            DataEvento,
            DataAniversarioAnterior,
            DataAniversario,
            DataAniversarioPeriodo,
            DataReferenciaIndice,
            DataIndexador,
            dp,
            dt,
            VariacaoIndicePUPAR,
            FatorCorrecaoPUPAR,
            FatorCorrecaoAcumuladoPUPAR,
            FatorCorrecaoAcumuladoPeriodoPUPAR,
            VariacaoIndicePUMTM,
            FatorCorrecaoPUMTM,
            FatorCorrecaoAcumuladoPUMTM,
            FatorCorrecaoAcumuladoPeriodoPUMTM
        } = newRow

        const body = {
            "CETIP": CETIP,
            "Indexador": Indexador,
            "Defasagem": Defasagem,
            "CalculoDiasIndexador": CalculoDiasIndexador,
            "FormulaIndexador": FormulaIndexador,
            "PeriodicidadeAtualizacaoMonetaria": PeriodicidadeAtualizacaoMonetaria,
            "MêsAniversarioAnualSemestral": MêsAniversarioAnualSemestral,
            "ProjecaoInflacao": ProjecaoInflacao,
            "InflacaoNegativa": InflacaoNegativa,
            "RecalculoProjecao": RecalculoProjecao,
            "CalculoFatorCorrecao": CalculoFatorCorrecao,
            "CasasFatorCorrecao": CasasFatorCorrecao,
            "DataEvento": DataEvento,
            "DataAniversarioAnterior": DataAniversarioAnterior,
            "DataAniversario": DataAniversario,
            "DataAniversarioPeriodo": DataAniversarioPeriodo,
            "DataReferenciaIndice": DataReferenciaIndice,
            "DataIndexador": DataIndexador,
            "dp": dp,
            "dt": dt,
            "VariacaoIndicePUPAR": VariacaoIndicePUPAR,
            "FatorCorrecaoPUPAR": FatorCorrecaoPUPAR,
            "FatorCorrecaoAcumuladoPUPAR": FatorCorrecaoAcumuladoPUPAR,
            "FatorCorrecaoAcumuladoPeriodoPUPAR": FatorCorrecaoAcumuladoPeriodoPUPAR,
            "VariacaoIndicePUMTM": VariacaoIndicePUMTM,
            "FatorCorrecaoPUMTM": FatorCorrecaoPUMTM,
            "FatorCorrecaoAcumuladoPUMTM": FatorCorrecaoAcumuladoPUMTM,
            "FatorCorrecaoAcumuladoPeriodoPUMTM": FatorCorrecaoAcumuladoPeriodoPUMTM
        }

        props.loading(true)

        return datalakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList
            .map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`)
            .join('&')

        props.loading(true)

        datalakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)

        datalakeService.paginate(endpoint).then((response) => {
            props.loading(false)

            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count, next, previous })
            setData(list)
        })
    }

    const dateColumn = (field, minWidth = 150) => ({
        field,
        headerName: field,
        flex: 1,
        minWidth,
        typeComponent: 'date',
        editable: true,
        renderCell: (params) =>
            params.value ? dayjs(params.value).format(DATE_FORMAT_SHOW) : ''
    })

    const numberColumn = (field, minWidth = 180) => ({
        field,
        headerName: field,
        flex: 1,
        minWidth,
        typeComponent: 'number',
        type: 'number',
        editable: true
    })

    const columns = [
        { field: 'ID', headerName: '#', disableColumnMenu: true, disableFilter: true, flex: true, minWidth: 80 },

        { field: 'CETIP', headerName: 'CETIP', flex: 1, minWidth: 150, editable: true },
        { field: 'Indexador', headerName: 'Indexador', flex: 1, minWidth: 150, editable: true },

        numberColumn('Defasagem'),
        { field: 'CalculoDiasIndexador', headerName: 'CalculoDiasIndexador', flex: 1, minWidth: 200, editable: true },
        { field: 'FormulaIndexador', headerName: 'FormulaIndexador', flex: 1, minWidth: 200, editable: true },
        { field: 'PeriodicidadeAtualizacaoMonetaria', headerName: 'PeriodicidadeAtualizacaoMonetaria', flex: 1, minWidth: 250, editable: true },
        { field: 'MêsAniversarioAnualSemestral', headerName: 'MêsAniversarioAnualSemestral', flex: 1, minWidth: 250, editable: true },

        numberColumn('ProjecaoInflacao'),
        numberColumn('InflacaoNegativa'),
        numberColumn('RecalculoProjecao'),

        { field: 'CalculoFatorCorrecao', headerName: 'CalculoFatorCorrecao', flex: 1, minWidth: 200, editable: true },

        numberColumn('CasasFatorCorrecao'),

        dateColumn('DataEvento'),
        dateColumn('DataAniversarioAnterior', 180),
        dateColumn('DataAniversario'),
        dateColumn('DataAniversarioPeriodo', 180),
        dateColumn('DataReferenciaIndice', 180),
        dateColumn('DataIndexador'),

        numberColumn('dp'),
        numberColumn('dt'),

        numberColumn('VariacaoIndicePUPAR', 220),
        numberColumn('FatorCorrecaoPUPAR', 220),
        numberColumn('FatorCorrecaoAcumuladoPUPAR', 260),
        numberColumn('FatorCorrecaoAcumuladoPeriodoPUPAR', 300),

        numberColumn('VariacaoIndicePUMTM', 220),
        numberColumn('FatorCorrecaoPUMTM', 220),
        numberColumn('FatorCorrecaoAcumuladoPUMTM', 260),
        numberColumn('FatorCorrecaoAcumuladoPeriodoPUMTM', 300),

        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                updateRow={updateRow}
                pagination={pagination}
                onChangePage={changePage}
                filterFunction={onFilter}
                customFilter={true}
            />
        </div>
    )
}

ParameterMemoriaCalculoFatorCorrecaoTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterMemoriaCalculoFatorCorrecaoTable